import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'vaccinations-records',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'vaccinations-records-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                    
                    {                           
                        transKey: 'breadcrumbs.vaccinations-records-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "vaccinations-records-index" */ '@/modules/configurations/catalogs/vaccinations-records/views/Index.vue')
        },
        {
            path: 'create',
            name: 'vaccinations-records-create',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'vaccinations-records-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.vaccinations-records-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.vaccinations-records-create',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "vaccinations-records-create" */ '@/modules/configurations/catalogs/vaccinations-records/views/Create.vue')
        },
        {
            path: 'edit/:id',
            name: 'vaccinations-records-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'vaccinations-records-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.vaccinations-records-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.vaccinations-records-edit',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "vaccinations-records-edit" */ '@/modules/configurations/catalogs/vaccinations-records/views/Edit.vue')
        }
    ]
}